export class OrderApprovalInputDto {
  //This calss is created for binding and UI purpose only
  itemsBelowFP: string = '';
  itemsAboveLP: string = '';
  totalExtendedPrice = 0.00;
  allowedPercentage = 0.00;
  approvalRequired = 'No';
  margin = 0.00;
}
